import React, { PropTypes } from 'react'

function YouTube({ id, className }) {
	if (id) {
		return (
			<iframe
				className={`youtube-video ${className}`}
				width="560"
				height="315"
				src={`https://www.youtube.com/embed/${id}`}
				frameBorder="0"
				allowFullScreen
			/>
		)
	}
	return null
}

YouTube.propTypes = {
	id: PropTypes.string,
	className: PropTypes.string
}

YouTube.defaultProps = {
	id: null,
	className: ''
}

export default YouTube



// WEBPACK FOOTER //
// ../components/YouTube/index.js